export default {
    data() {
        return {
            boxTypes: [],
            packageTypes: [],
        }
    },
    methods: {
        getPackageBoxTypes() {
            return new Promise((resolve, reject) => {
                if (!this.boxTypes.length) {
                    this.$store.dispatch('shipments/shipmentsOrders/getPackageBoxTypes')
                        .then(response => {
                            this.boxTypes = response.data.results
                            resolve()
                        })
                        .catch(error => reject(error))
                } else {
                    resolve()
                }
            })
        },
        getPackagesTypes() {
            return new Promise((resolve, reject) => {
                if (!this.packageTypes.length) {
                    this.$store.dispatch('shipments/shipmentsOrders/getPackagesTypes')
                        .then(response => {
                            this.packageTypes = response.data.results
                            resolve()
                        })
                        .catch(error => reject(error))
                } else {
                    resolve()
                }
            })
        },
    },
}